export const PRESIDENT = "President";
export const VP_Of_Sales = "VP of Sales";
export const Task_MANAGER = "Task Manager";
export const SERVICE_MANGER = "Service Manager";
export const CERTIFIED_APPLICATOR_TECH = "Certified Applicator (Tech)";
export const LEAD_TECHNICIAN_TECH = "Lead Technician (Tech)";
export const TECHNICIAN_TECH = "Technician (Tech)";
export const APPRENTICE_TECH = "Apprentice (Tech)";
export const CUSTOMER_RELATIONS_MANGER = "Customer Relations Manager";
export const CUSTOMER_RELATIONS_APPRENTICE = "Customer Relations Apprentice";
export const CUSTOMER_RELATIONS_SPECIALIST = "Customer Relations Specialist";
export const EXECUTIVE_ASSISTANT = "Executive Assistant";
export const RETENTION_SPECIALIST = "Retention Specialist";
export const SUMMER_COORDINATOR = "Summer Coordinator";
export const IT = "IT";
export const ROUTE_MANAGER = "Route Manager";
export const REGIONAL_MANAGER = "Regional Manager";
export const TEAM_LEADER = "Team Leader";
export const CO_TEAM_LEADER = "Co Team Leader";
export const HIRING_MANAGER = "Hiring Manager";
export const LEAD_SETTER = "Lead Setter";
export const BRANCH_MANAGER = "Branch Manager";
export const REGIONAL_OPERATIONS_MANAGER = "Regional Operations Manager";
export const SALES_OPERATIONS_MANAGER = "Sales Operations Manager";

// Returns true when the user holds a given position, tolerant of how the
// position is stored. The `Position (TEXT)` rollup is empty for some records
// (multi-position users, certain linked-record setups), which silently broke
// Branch-Manager-only views that gated solely on it. The `Position (from
// Position)` lookup is the reliable array of position name(s). See
// TaskDetails.jsx, which already falls back this way for "Task Manager".
export const userHasPosition = (userInfo, position) => {
  if (!userInfo || !position) return false;
  if (userInfo["Position (TEXT)"]?.trim() === position) return true;
  const fromPosition = userInfo["Position (from Position)"];
  return (
    Array.isArray(fromPosition) &&
    fromPosition.some((p) => typeof p === "string" && p.trim() === position)
  );
};

export const isBranchManager = (userInfo) =>
  userHasPosition(userInfo, BRANCH_MANAGER);

export const TextingPositions = [
  PRESIDENT,
  SERVICE_MANGER,
  CERTIFIED_APPLICATOR_TECH,
  LEAD_TECHNICIAN_TECH,
  TECHNICIAN_TECH,
  APPRENTICE_TECH,
  BRANCH_MANAGER,
];

export const TrainingPositions = [
  PRESIDENT,
  VP_Of_Sales,
  SERVICE_MANGER,
  CERTIFIED_APPLICATOR_TECH,
  LEAD_TECHNICIAN_TECH,
  TECHNICIAN_TECH,
  CUSTOMER_RELATIONS_MANGER,
  APPRENTICE_TECH,
  CUSTOMER_RELATIONS_SPECIALIST,
  CUSTOMER_RELATIONS_APPRENTICE,
  EXECUTIVE_ASSISTANT,
  RETENTION_SPECIALIST,
  SUMMER_COORDINATOR,
  ROUTE_MANAGER,
  REGIONAL_MANAGER,
  TEAM_LEADER,
  CO_TEAM_LEADER,
  HIRING_MANAGER,
  BRANCH_MANAGER,
];

export const SalesRecordingPositions = [
  PRESIDENT,
  VP_Of_Sales,
  TEAM_LEADER,
  ROUTE_MANAGER,
];

export const PayrollPositions = [
  PRESIDENT,
  VP_Of_Sales,
  SERVICE_MANGER,
  CERTIFIED_APPLICATOR_TECH,
  LEAD_TECHNICIAN_TECH,
  TECHNICIAN_TECH,
  CUSTOMER_RELATIONS_MANGER,
  APPRENTICE_TECH,
  EXECUTIVE_ASSISTANT,
  RETENTION_SPECIALIST,
  SUMMER_COORDINATOR,
  ROUTE_MANAGER,
  REGIONAL_MANAGER,
  TEAM_LEADER,
  CO_TEAM_LEADER,
  HIRING_MANAGER,
  BRANCH_MANAGER,
];

export const StatsPositions = [
  PRESIDENT,
  VP_Of_Sales,
  SERVICE_MANGER,
  CERTIFIED_APPLICATOR_TECH,
  LEAD_TECHNICIAN_TECH,
  TECHNICIAN_TECH,
  CUSTOMER_RELATIONS_MANGER,
  APPRENTICE_TECH,
  EXECUTIVE_ASSISTANT,
  RETENTION_SPECIALIST,
  SUMMER_COORDINATOR,
  ROUTE_MANAGER,
  REGIONAL_MANAGER,
  TEAM_LEADER,
  CO_TEAM_LEADER,
  HIRING_MANAGER,
  BRANCH_MANAGER,
];

export const TasksPositions = [
  PRESIDENT,
  VP_Of_Sales,
  SERVICE_MANGER,
  CERTIFIED_APPLICATOR_TECH,
  LEAD_TECHNICIAN_TECH,
  TECHNICIAN_TECH,
  CUSTOMER_RELATIONS_MANGER,
  APPRENTICE_TECH,
  CUSTOMER_RELATIONS_SPECIALIST,
  CUSTOMER_RELATIONS_APPRENTICE,
  EXECUTIVE_ASSISTANT,
  RETENTION_SPECIALIST,
  SUMMER_COORDINATOR,
  ROUTE_MANAGER,
  REGIONAL_MANAGER,
  TEAM_LEADER,
  CO_TEAM_LEADER,
  HIRING_MANAGER,
  BRANCH_MANAGER,
];

export const TaskManagerPositions = [
  PRESIDENT,
  VP_Of_Sales,
  Task_MANAGER,
  SERVICE_MANGER,
  LEAD_TECHNICIAN_TECH,
  TECHNICIAN_TECH,
  EXECUTIVE_ASSISTANT,
  RETENTION_SPECIALIST,
  SUMMER_COORDINATOR,
  ROUTE_MANAGER,
  REGIONAL_MANAGER,
  TEAM_LEADER,
  CO_TEAM_LEADER,
  HIRING_MANAGER,
  BRANCH_MANAGER,
];
